/**
 * @file Re-exports the beneficiaries table and its imperative handle type.
 */
import BeneficiariesTable from "./BeneficiariesTable";

export type { BeneficiariesTableHandle } from "./BeneficiariesTable";
export default BeneficiariesTable;
